// @ts-nocheck
import industryHighlights from '@core/config/industryHighlights';
import type { IndustryHighlight } from '@core/config/industryHighlights';

export function getCategoryByName(name: string): IndustryHighlight | undefined {
  return industryHighlights.find((industry) => industry.name === name);
}
